import script from "./wellness.vue?vue&type=script&setup=true&lang=js"
export * from "./wellness.vue?vue&type=script&setup=true&lang=js"

import "./wellness.vue?vue&type=style&index=0&id=9192cdc8&lang=css"

const __exports__ = script;

export default __exports__